module.exports = {
      id: "icon-twitter-usage",
      viewBox: "0 0 19.798 20.251",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#icon-twitter",
      toString: function () {
        return this.url;
      }
    }